import gql from 'graphql-tag';

export const redeemCode = gql`
  mutation linkMockExams($examLinkCode: String!) {
    linkMockExams(examLinkCode: $examLinkCode) {
      code
      subCode
      message
      success
      # examList {
      #   id
      #   examRounds {
      #     id
      #     examCards {
      #       id
      #       exam {
      #         id
      #         title
      #         examDate
      #       }
      #     }
      #   }
      # }
    }
  }
`;
